import clsx from 'clsx';
import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import styles from 'components/Bookings2/Abandoned/Card/AbandonedBookingCard.module.scss';
import Button from 'components/UI/V2/Button/Button';
import { useHasPremiumAccess } from 'hooks';
import { BookingAttempt } from 'model/BookingAttempt';
import React from 'react';
import { Link } from 'react-router-dom';
import { ClientsPath } from 'routes/Paths';
import { hashForUrl } from 'utils/HashUtils';

interface AbandonedBookingCardProps {
    bookingAttempt: BookingAttempt;
    onSendSms?: (bookingAttempt: BookingAttempt) => void;
    onBook?: (bookingAttempt: BookingAttempt) => void;
}

export const AbandonedBookingCard: React.FC<AbandonedBookingCardProps> = ({ bookingAttempt, onBook, onSendSms }) => {
    const hasTwoWaySMSPremiumAccess = useHasPremiumAccess('two_way_sms');

    const { type, isLoading } = useAbandonedBookings();

    const clientPath = React.useMemo(() => {
        const hash = hashForUrl({ clientId: bookingAttempt.customerId, petId: undefined });

        return `${ClientsPath}/${hash}`;
    }, [bookingAttempt.customerId]);

    return (
        <div className={styles.root}>
            <div className={clsx(styles.header, styles.row)}>
                <Link
                    to={clientPath}
                    className={styles.customerLink}
                >
                    <p className={styles.name}>{bookingAttempt.name}</p>
                    <p className={styles.email}>{bookingAttempt.email}</p>
                </Link>

                <div>
                    <div className={styles.date}>{bookingAttempt.abandonedDate.format('MMM DD, hh:mm a')}</div>
                </div>
            </div>

            <div className={styles.row}>
                <div>
                    <h6>Type</h6>
                    <p>{bookingAttempt.type}</p>
                </div>
                <div>
                    <h6>Pets</h6>
                    <p>{bookingAttempt.pets}</p>
                </div>
            </div>

            <div className={styles.row}>
                <div>
                    <h6>Abandoned Step</h6>
                    <p>{bookingAttempt.abandonedStepName}</p>
                </div>
            </div>

            <div className={styles.footer}>
                {type !== 'converted' && (
                    <Button
                        label="Book"
                        variant="green"
                        isLoading={isLoading.get(bookingAttempt.id) ?? false}
                        onClick={() => onBook?.(bookingAttempt)}
                    />
                )}
                {hasTwoWaySMSPremiumAccess && (
                    <Button
                        label="Send SMS"
                        variant="black"
                        onClick={() => onSendSms?.(bookingAttempt)}
                    />
                )}
            </div>
        </div>
    );
};
